class BenefitsMarquee extends HTMLElement {
  constructor() {
    super();
    this.track = null;
    this.speed = 2;
    this.position = 0;
    this.animationId = null;
    this.originalWidth = 0;
    this.mediaQuery = window.matchMedia('(min-width: 750px)');
    this.handleResize = this.handleResize.bind(this);
    this.handleMediaChange = this.handleMediaChange.bind(this);
  }

  connectedCallback() {
    const trackEl = this.querySelector('.benefits-marquee__track');
    if (!trackEl || !(trackEl instanceof HTMLElement)) return;
    this.track = trackEl;

    const speedVal = this.dataset.speed;
    this.speed = speedVal ? parseFloat(speedVal) || 2 : 2;

    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', this.handleMediaChange);
    } else {
      this.mediaQuery.addListener(this.handleMediaChange);
    }

    // Wait for fonts to load since they affect width
    if (document.fonts) {
      document.fonts.ready.then(() => {
        this.handleMediaChange();
      });
    } else {
      setTimeout(() => this.handleMediaChange(), 100);
    }
  }

  disconnectedCallback() {
    this.stopAnimation();
    window.removeEventListener('resize', this.handleResize);
    if (this.mediaQuery.removeEventListener) {
      this.mediaQuery.removeEventListener('change', this.handleMediaChange);
    } else {
      this.mediaQuery.removeListener(this.handleMediaChange);
    }
  }

  handleMediaChange() {
    if (this.mediaQuery.matches) {
      this.initMarquee();
    } else {
      this.stopAnimation();
      if (this.track) {
        this.track.style.transform = '';
      }
    }
  }

  initMarquee() {
    if (!this.track) return;

    const items = Array.from(this.track.children);
    if (!items.length) return;

    // Avoid re-cloning if already initialized
    if (!this.track.dataset.initialized) {
      const gap = 40; // Must match CSS gap
      this.originalWidth = this.track.scrollWidth + gap;

      const setOfItemsHtml = this.track.innerHTML;
      let currentWidth = this.originalWidth;
      const requiredWidth = window.innerWidth * 2 + this.originalWidth;

      while (currentWidth < requiredWidth) {
        this.track.insertAdjacentHTML('beforeend', setOfItemsHtml);
        currentWidth += this.originalWidth;
      }

      this.track.dataset.initialized = 'true';
      this.track.dataset.originalWidth = String(this.originalWidth);
    } else {
      this.originalWidth = parseFloat(this.track.dataset.originalWidth) || this.track.scrollWidth / 2;
    }

    window.removeEventListener('resize', this.handleResize);
    window.addEventListener('resize', this.handleResize);
    this.startAnimation();
  }

  handleResize() {
    // optional resize logic
  }

  stopAnimation() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
      this.animationId = null;
    }
  }

  startAnimation() {
    if (!this.track) return;

    this.stopAnimation();
    this.position = 0;

    const animate = () => {
      if (!this.mediaQuery.matches) {
        this.stopAnimation();
        return;
      }

      this.position -= this.speed;

      if (Math.abs(this.position) >= this.originalWidth) {
        this.position += this.originalWidth;
      }

      if (this.track) {
        this.track.style.transform = `translate3d(${this.position}px, 0, 0)`;
      }
      this.animationId = requestAnimationFrame(animate);
    };

    this.animationId = requestAnimationFrame(animate);
  }
}

if (!customElements.get('benefits-marquee')) {
  customElements.define('benefits-marquee', BenefitsMarquee);
}
